import { useMemo } from "react";
import { countryOption } from "../components/CountryName.tsx";
import type { FilterOption } from "../components/filters/specs.ts";

/** Country codes as filter options labelled "🇳🇴 Norway"; stable while `codes` is. */
export function useCountryOptions(codes: string[] | undefined): FilterOption[] {
  return useMemo(
    () =>
      (codes ?? []).map((code) => {
        const { label } = countryOption(code);
        return { value: code, label };
      }),
    [codes],
  );
}
